/*
  Author : Om Athalye
  email: om96athalye@gmail.com
  Bitbucket: https://bitbucket.org/OmAthalye/
*/

import React from "react";
import Head from "next/head";

import styled from "styled-components";
import GlobalStyle from "static/next/css/GlobalStyle";

import {
  Header,
  SegmentAnalytics
} from "components";

const PartnersTermsAndConditions = () => {
  return (
    <>
      <Head>
        <title>Wealthy | Partner&rsquo;s Terms and conditions | Invest wisely</title>
        <meta content="Join Wealthy for a bright Wealth Management career that goes beyond quotas. We have more than 100+ financial products and have the best compensation plan." name="description" />
        <meta content="Wealth Management Jobs, Relationship Management Jobs, Private Banker Jobs, Portfolio Manager Jobs, Investment Manager Jobs" name="keywords" />
        <link href="https://i.wlycdn.com/wealthy-home-page/new-fav-icon.png" rel="icon" />
        <link as="style" href="static/next/css/header-footer.css" rel="preload" />
        <link href="static/next/css/header-footer.css" rel="stylesheet" />
      </Head>
      <SegmentAnalytics />
      <GlobalStyle />
      <section>
        <Header
          isWhite
          sticky={false}
        />
      </section>
      <Wrapper>
        <div>
          <div className="page-container wl-primary-text">

            {/* Section: Partner's Terms and Conditions */}
            <div>
              <h1><b>Partner&rsquo;s Terms and Conditions</b></h1>
            </div>

            {/* Section: USER REGISTRATION*/}
            <div>
              <h2><b>1. USER REGISTRATION</b></h2>
              <ul className="bullet-list">
                <li>I hereby agree and give consent for opening of investment account facility with WealthyIN Customer Services Pvt Ltd, an AMFI registered distributor for undertaking online mutual fund transactions and other investment products such as Fixed Deposits, Market Linked Securities, Private Securities, etc. on website or mobile application (jointly referred to as www.wealthy.in)</li>
                <li>I hereby give my consent to be contacted on contact number and email id provided by me for providing me information on the product and services of WealthyIN.</li>
              </ul>
              <br />
            </div>

            {/* Section: BANK DETAILS */}
            <div>
              <h2><b>2. BANK DETAILS</b></h2>
              <ul className="bullet-list">
                <li>I hereby declare that the details of the bank provided on the platform belongs to me and the primary account holder of the account is me and any refunds/redemption should be credited to the aforementioned account which is provided by me.</li>
                <li>I hereby declare that the Debit Card and/or Netbanking account and/or ACH mandate used to make the transaction are linked to the bank account of which I am the primary account holder.</li>
                <li>I authorize WealthyIN and/or its authorized service provider(s) to - execute the NACH/Direct Debit mandate, subsequent NACH/Direct debit instructions related to my investments and electronic money transfer instructions through online payment gateway(s)- carry out all mutual fund subscription/ redemption/ non-financial instructions which I provide through the website www.wealthy.in using the Email and Password (log-in credentials) associated with my Investment Account , and/or through any other mode, including on paper;  and communicate with the AMC on my behalf for financial and non-financial transactions and to receive details of my investment from the AMC.</li>
              </ul>
              <br />
            </div>

            {/* Section: INFORMATION WE COLLECT */}
            <div>
              <h2><b>3. KYC INFORMATION</b></h2>
              <ul className="bullet-list">
                <li>I hereby allow WealthyIN to utilize my information such as PAN, photo, name, father's name, Date of Birth, gender, marital status, proof of address, address and signature etc. for sending it to KYC Registration Agency (KRA) as part of Know Your Customer (KYC) norm & Asset Management Companies (AMC) as part of my application to AMCs. This can be used for the purpose of validation and to comply with the legal and regulatory requirements. I hereby accept that my address will be updated at the AMC as per my KYC address.</li>
                <li>I hereby accept that the signature and other details available in the CVL-KRA records/system may be fetched/used for signature verification by AMC/their R&T for processing any requests made by me through www.wealthy.in and in the event of such signature not being available or legible in the CVL KRA records/system, I understand and agree that the AMC shall be entitled to carry out further checks to validate the authenticity of the request and/or to reject/disallow any transaction in connection herewith.</li>
              </ul>
              <br />
            </div>

            {/* Section: TERMS OF TRANSACTIONS FOR MUTUAL FUNDS */}
            <div>
              <h2><b>4. TERMS OF TRANSACTIONS FOR MUTUAL FUNDS</b></h2>
              <ul className="bullet-list">
                <li>I acknowledge that investment products do not pertain to WealthyIN and the company is not in the business of providing investment advice</li>
                <li>I acknowledge that WeathyIN will forward my transaction to AMC after completing "Know Your Client" (KYC) process. In the event where KYC process is not completed by me to the satisfaction of the AMC, I hereby authorize the AMC, to redeem the funds invested in the Scheme, in favour of the applicant, at the applicable NAV prevailing on the date of such redemption and undertake such other action with such funds that may be required by the law.</li>
                <li>
                  <p>I understand that WealthyIN will process my instructions on a best effort basis. I understand that my instructions will be processed the same business day if received before the cut-off time(s) specified by WealthyIN, ELSE my instructions will be processed on the next business day. WealthyIN may specify cut-off time(s) earlier than the time(s) specified by the AMC/ SEBI. I will not dispute and/or hold WealthyIN responsible for any loss, notional or otherwise, incurred because of</p>
                  <ol>
                    <li>delays either at the Bank, Registrar and Transfer Agency or AMC.</li>
                    <li>rejection of my instructions by the Bank, Registrar and Transfer Agency or AMC.</li>
                    <li>processing of instructions authenticated by my Login Credentials.</li>
                    <li>non-availability or non-accessibility of the Website, telephone(s), or office(s) of WealthyIN in case of circumstances beyond WealthyIN's control.</li>
                  </ol>
                  <br />
                </li>
                <li>I confirm that the ARN holder (WealthyIN Customer Services Pvt Ltd) has disclosed to me all the commissions (trail commission or any other mode), payable to them for the different competing Schemes of various Mutual Funds amongst which the Scheme is being recommended to me. I confirm that details provided by me are true and correct.</li>
                <li>I understand that the ARN holder (WealthyIN Customer Services Pvt Ltd) would help me maintain asset allocation in line with the risk profile. I will not dispute and/or hold WealthyIN responsible for any loss, notional or otherwise, incurred because of suggested investment and withdrawal amounts in different mutual fund schemes. I also understand ARN holder would do this on a best effort basis.</li>
                <li>I acknowledge if I have placed a redemption (full or partial) request from a channel other ARN holder (WealthyIN Customer Services Pvt Ltd) then the available withdrawal amount on www.wealthy.in may not be in sync. I acknowledge that under such circumstances redemption order may fail or be partially fulfilled.</li>
                <li>I understand that after my withdrawal request is processed by WealthyIN the money may take up to 1 business day (for debt funds) and 3 business days (for equity funds) to be credited to my bank account. I confirm that the bank account details displayed at the time of redemption request are correct and I am the primary account holder of the bank account displayed. I authorize AMC to use this bank account to redeem my amount.</li>
                <li>I understand that there may be early exit charges as per SID / SAI / KIM of the scheme(s) chosen on the platform.</li>
              </ul>
              <br />
            </div>

            {/* Section: TERMS OF TRANSACTIONS FOR OTHER INVESTMENT PRODUCTS */}
            <div>
              <h2><b>5. TERMS OF TRANSACTIONS FOR OTHER INVESTMENT PRODUCTS</b></h2>
              <ul className="bullet-list">
                <li>I acknowledge that investment products do not pertain to WealthyIN and the company is not in the business of providing investment advice</li>
                <li> acknowledge that WeathyIN will forward my purchase request / redirect me to the Security Owner / FD Issuer after completing "Know Your Client" (KYC) process. In the event where KYC process is not completed by me to the satisfaction of the seller, I hereby authorize the platform, to reverse the amount invested.</li>
                <li>
                  <p>I understand that WealthyIN will process my instructions on a best effort basis. I understand that my instructions will be processed the same business day if received before the cut-off time(s) specified by WealthyIN, ELSE my instructions will be processed on the next business day. I will not dispute and/or hold WealthyIN responsible for any loss, notional or otherwise, incurred because of</p>
                  <ol>
                    <li>delays either at the Payment Gateway, FD Issuer, Security Seller.</li>
                    <li>rejection of my KYC details by the FD issuer or Security Seller.</li>
                    <li>non-availability or non-accessibility of the Website, telephone(s), or office(s) of WealthyIN in case of circumstances beyond WealthyIN's control.</li>
                  </ol>
                  <br />
                </li>
                <li>I understand that the settlement of purchased securities may take upto 7 working days to my demat account, and I have understood the risks involved in purchase of market lined securities.</li>
                <li>I understand that the rate of interest on FD booked may differ from the day I made the investment.</li>
              </ul>
              <br />
            </div>

            {/* Section: UNDERTAKING BY USER */}
            <div>
              <h2><b>6. UNDERTAKING BY USER</b></h2>
              <ul className="bullet-list">
                <li>I understand Mutual Fund and market linked investments are subject to market risks, read all scheme-related documents carefully. Having read and understood the content of the SID / SAI / KIM of the scheme(s) chosen on the platform,I hereby apply for units of the scheme. I have read and understood the terms, conditions, details, rules and regulations governing the scheme  hereby declare that the amount invested in the scheme is through legitimate source only and does not involve designed for the purpose of the contravention of any Act, Rules, Regulations, Notifications or Directives of the provisions of the Income Tax Act, Anti Money Laundering Laws, Anti-Corruption Laws or any other applicable laws enacted by the Government of India from time to time. I have not received nor have been induced by any rebate or gifts, directly or indirectly in making this investment. I confirm that the funds invested in the Scheme, legally belongs to me.</li>
                <li>I hereby accept that for any transactions that are submitted offline i.e. with wet signatures, the signature available in my KYC records would be used for signature verification. I agree and understand that I shall be solely liable to inform the Distributor/AMC in case of any change in my KYC information including change in signature etc. and in the event of my signature not being updated, available or legible in KYC records, the Distributor/AMC would be within its rights to carry out further checks to validate the authenticity of the request or reject any such offline request based on existing KYC information.</li>
                <li>I shall execute and deliver to WealthyIN from time to time such other documents as may be required for updation of records if any. I further agree that any false/misleading information given by me or suppression of any material fact will render my account liable for termination.</li>
              </ul>
              <br />
            </div>

            {/* Section: ACKNOWLEDGEMENT */}
            <div>
              <h2><b>7. ACKNOWLEDGEMENT</b></h2>
              <ul className="bullet-list">
                <li>I acknowledge that I have read the Terms and Conditions which are applicable for investment account facility on WealthyIN and that I have read and understood the said Terms and Conditions and that a copy of the Terms and Conditions is available on www.wealthy.in and I hereby severally agree and undertake to abide by these Terms and Conditions. I further agree to accept the updated Terms and Conditions as may be notified from time to time on www.wealthy.in before executing the transactions.</li>
                <li>I understand and agree that, pursuant to the Terms and Conditions, I hereby authorise WealthyIN to execute my instructions for purchase/redemption/switch/ sell or other transaction/activities in respect of online mutual fund transactions on my behalf, as may be instructed by me from time to time on www.wealthy.in</li>
                <li>I hereby declare that the details furnished through the process are true and correct to the best of my knowledge and belief, and I undertake to inform you of any changes therein, immediately. In case any of the above information is found to be false or untrue or misleading or misrepresenting, I am aware that I may be held liable for it and my account may become liable for termination.</li>
                <li>The laws of India govern this Agreement. All disputes are subject, firstly, to mediation, and then by Arbitration by a sole arbitrator appointed by WealthyIN. The venue of arbitration will be Bangalore.</li>
                <li>I declare that I am not politically exposed, neither a relative of politically exposed person. My primary source of income is salary. I hereby declare that the information provided is true and correct to the best of my knowledge. In the event of any change in the information provided, I will notify WealthyIN Customer Services Pvt Ltd (WealthyIN) immediately.</li>
              </ul>
              <br />
            </div>
          </div>
        </div>
      </Wrapper>
      <style jsx>{`
        .bullet-list {
          margin-left: 2em;
          list-style-type: disc;
        }
        .bullet-list ol {
          margin-left: 2em;
        }
        .page-container p {
          margin: 0 0 15px;
          color: #3c3c3c;
          font-family: Avenir-Light;
          font-weight: 400;
          font-size: 18px;
          line-height: 26px;
          letter-spacing: .3px;
        }
        a {
          color: black;
          font-size: 18px;
          text-decoration: underline;
        }
        .page-container {
          margin: auto;
          padding: 2em 5% 6em;
          max-width: 950px;
        }
        .wl-primary-text {
          color: #3c3c3c;
          font-family: "Avenir-Book";
          font-size: 18px;
          font-weight: 300;
        }
        .page-container h1 {
          font-family: "Avenir-Heavy";
          padding-bottom: .25em;
          line-height: normal;
          color: rgba(0,0,0,.8);
          border-bottom: 1px solid #ccc;
          font-size: 2em;
          margin-bottom: 35px;
        }
        .page-container h2 {
          font-family: "Avenir-Heavy";
          font-weight: 500;
          line-height: normal;
          color: rgba(0,0,0,.8);
          margin-top: 40px;
          font-size: 1.5em;
          margin-bottom: 10px;
        }
        b {
          font-weight: 700;
        }
        h4 {
          margin-top: 10px;
          margin-bottom: 10px;
          font-size: 18px;
          font-family: inherit;
          font-weight: 500;
          line-height: 1.1;
        }
        @media (max-width : 768px) {
          .page-container p {
            margin: 0 0 10px;
            color: #3c3c3c;
            font-family: Avenir-Light;
            font-weight: 400;
            font-size: 16px;
            line-height: 26px;
            letter-spacing: .3px;
          }
          a {
            font-size: 16px;
          }
        }
      `}
      </style>
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: 768px){
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

export default PartnersTermsAndConditions;
